import React from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

const StoreChangeIndicator = () => {
  const { selectedStore, lastStoreChange } = useSelector((state) => state.store);
  const { status: productStatus } = useSelector((state) => state.product);
  const { status: employeeStatus } = useSelector((state) => state.employee);
  const { loading: warehouseLoading } = useSelector((state) => state.warehouse);

  // Show indicator when data is being loaded after store change
  const isLoading = (productStatus === 'loading' || employeeStatus === 'loading' || warehouseLoading) && selectedStore;

  return (
    <Fade in={isLoading} timeout={300}>
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          p: 3,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          boxShadow: 3,
          backdropFilter: 'blur(4px)',
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Loading {selectedStore?.name} data...
        </Typography>
      </Box>
    </Fade>
  );
};

export default StoreChangeIndicator; 